import { useEffect, useState } from "react"
import type { DataTypePaging, SuccessFetch } from "types"
import type { FetchType, FormType, ListType } from "../../types"
import { useApi } from "utils"
import { default_option, delivery_option } from "../vars"

// export function usePurchaseList(params: FormType) {
//   const defaultValue = {
//     payload: [],
//     pagination_data: {
//         page: 0,
//         pages: 0,
//         size: 0,
//         total: 0
//     }
//   }
//   const api = useApi()
//   const [data, setData] = useState<DataTypePaging<ListType>>(defaultValue)
//   // const [filter, setFilter] = useState<FormType>(params)
//   const [isLoading, setLoading] = useState<boolean>(false) 

//   useEffect(() => {
//     refetch()

//     return () => {
//       setData(defaultValue)
//       setLoading(false)
//     }

//     // eslint-disable-next-line
//   }, [ filter ])

//   const refetch = (): void => {
//     setLoading(true)

//     api.get("/purchaseorder/by-date", { params: { 
//       date_from: filter.DateFrom, 
//       date_end: filter.DateEnd, 
//       approval_satatus: filter.Approval, 
//       delivery_status: filter.Delivered,
//       total: filter?.total,
//       page: filter?.page,
//       limit: filter?.limit,
//       pages: filter?.pages
//     }})
//     .then((res: SuccessFetch<DataTypePaging<FetchType>>) => {
//       setData({
//         payload: res.data.payload.map((item: FetchType) => ({
//           ...item,
//           approval: default_option.find(opt => opt.value === String(item.approval_status))?.label ?? "-",
//           delivery: delivery_option.find(opt => opt.value === String(item.po_delivery_status))?.label ?? "-"
//         })),
//         pagination_data: res.data.pagination_data
//       })
//     })
//     .catch(() => setData(defaultValue))
//     .finally(() => setLoading(false))
//   }

//   return { data, filter, isLoading, refetch, setFilter }
// }

export function usePurchaseList(params: FormType) {
  const defaultValue = {
    payload: [],
    pagination_data: {
        page: 0,
        pages: 0,
        size: 0,
        total: 0
    }
  }
  const api = useApi()
  const [data, setData] = useState<DataTypePaging<ListType>>(defaultValue)
  const [isLoading, setLoading] = useState<boolean>(false) 

  const refetch = () => {
    setLoading(true)

    api.get("/purchaseorder/by-date", { params: { 
      date_from: params.DateFrom, 
      date_end: params.DateEnd, 
      approval_satatus: params.Approval, 
      delivery_status: params.Delivered,
      total: params?.total,
      page: params?.page,
      limit: params?.limit,
      pages: params?.pages
    } })
    .then((res: SuccessFetch<DataTypePaging<FetchType>>) => {
      setData({
        payload: res.data.payload.map((item: FetchType) => ({
          ...item,
          approval: default_option.find(opt => opt.value === String(item.approval_status))?.label ?? "-",
          delivery: delivery_option.find(opt => opt.value === String(item.po_delivery_status))?.label ?? "-"
        })),
        pagination_data: res.data.pagination_data
      })
    })
    .catch(() => setData(defaultValue))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    api.get("/purchaseorder/by-date", { params: { 
      date_from: params.DateFrom, 
      date_end: params.DateEnd, 
      approval_satatus: params.Approval, 
      delivery_status: params.Delivered,
      total: params?.total,
      page: params?.page,
      limit: params?.limit,
      pages: params?.pages
    } })
    .then((res: SuccessFetch<DataTypePaging<FetchType>>) => {
      setData({
        payload: res.data.payload.map((item: FetchType) => ({
          ...item,
          approval: default_option.find(opt => opt.value === String(item.approval_status))?.label ?? "-",
          delivery: delivery_option.find(opt => opt.value === String(item.po_delivery_status))?.label ?? "-"
        })),
        pagination_data: res.data.pagination_data
      })
    })
    .catch(() => setData(defaultValue))
    .finally(() => setLoading(false))
  
    return () => {
      setData(defaultValue)
      setLoading(true)
    }
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}